<fgb-page-header
  [pageTitle]="'payment.page.title'"
  [backButtonLink]="'/payment'"
></fgb-page-header>

<div class="container">
  <div class="success-card">
    <div
      class="success-card-header d-flex align-items-center justify-content-center gap-2"
    >
      <i class="material-icons text-success">add_card</i>
      <span class="success-title text-success text-capitalize">{{
        "ecash.success.page.title" | translate
      }}</span>
    </div>
    <div
      class="success-card-body d-flex flex-column align-items-center justify-content-between"
    >
      <p class="success-message text-center mb-0">
        {{ "ecash.success.page.card.added" | translate }}
      </p>
      <div class="checkmark-circle">
        <svg class="checkmark" viewBox="0 0 52 52">
          <circle class="checkmark-bg" cx="26" cy="26" r="25" fill="none" />
          <path class="checkmark-check" fill="none" d="M14 27 l8 8 l16 -16" />
        </svg>
      </div>
      <button
        [routerLink]="['/payment']"
        type="button"
        class="btn btn-danger close-btn fw-bold"
      >
        {{ "ecash.success.page.close.button" | translate }}
      </button>
    </div>
  </div>
</div>
